const ProductPricing = {
    initClassicPricing(parent) {
        let options = {}, cookieOptions;
        if (typeof window.directoryPricingSwitchOptions == 'object') {
            $.extend(options, window.directoryPricingSwitchOptions);
            $.cookie('directoryPricingSwitchOptions', JSON.stringify(options))
        } else {
            cookieOptions = $.cookie('directoryPricingSwitchOptions');
            if (cookieOptions) {
                cookieOptions = JSON.parse(cookieOptions);
                if (typeof cookieOptions == 'object') {
                    $.extend(options, cookieOptions);
                }
            }
        }

        options.annual = $.extend({ name: 'Annual', code: '4jod77', price: 67}, options.annual || {});
        options.lifetime = $.extend({name: 'Lifetime', code: 'gupfij', price: 127}, options.lifetime || {});
        SaleHoo.TrackedEvents.Checkout.loadCheckoutData([options.annual.code, options.lifetime.code]);

        let $prices = $(parent).find('.price-box'),
            $annualModal = $('#Pricing-Annual'),
            $lifetimeModal = $('#Pricing-Lifetime');

        let $annualPrice = $prices.first(),
            $lifetimePrice = $prices.last();

        $annualPrice.find('.price .number').text('$' + options.annual.price);
        $annualModal.find('.order-preferred-option').val(options.annual.code);
        $annualModal.find('.order-slug').val(options.annual.code).trigger('change');
        $annualModal.find('.price .number').text('$' + options.annual.price);

        $lifetimePrice.find('.price .number').text('$' + options.lifetime.price);
        $lifetimeModal.find('.order-preferred-option').val(options.lifetime.code);
        $lifetimeModal.find('.order-slug').val(options.lifetime.code).trigger('change');
        $lifetimeModal.find('.price .number').text('$' + options.lifetime.price);
    },

    initDropshipPricing(parent, options = {}, triggerToggleChange = true) {
        options = $.extend({}, options);
        options.basicMonthly = $.extend({ name: 'Monthly', code: 'r8tz7i', price: 27, per: '/month' }, options.basicMonthly || {});
        options.premiumMonthly = $.extend({ name: 'Monthly', code: 'divyk0', price: 97, per: '/month' }, options.premiumMonthly || {});
        options.basicAnnual = $.extend({ name: 'Annual', code: 'r2hbko', price: 270, per: '/year' }, options.basicAnnual || {});
        options.premiumAnnual = $.extend({ name: 'Annual', code: 'aw4kd3', price: 970, per: '/year' }, options.premiumAnnual || {});
        SaleHoo.TrackedEvents.Checkout.loadCheckoutData([
            options.basicMonthly.code,
            options.premiumMonthly.code,
            options.basicAnnual.code,
            options.premiumAnnual.code
        ]);
        
        let $switcher = $('[id^=SignUpModalDropship], ' + parent).find('.switch-toggle');

        $switcher.on('click', 'input.check', (e) => {
            if ($(e.target).prop('checked')) {
                $(e.delegateTarget).find('#filt-javascript').trigger('click');
            } else {
                $(e.delegateTarget).find('#filt-css').trigger('click');
            }
        });

        $switcher.on('click', '#filt-css', (e) => {
            if (typeof options.percentOff !== 'undefined') {
                $switcher.find(options.percentOff).css('opacity', '0');
            } else {
                $switcher.find('#filt-javascript').next('span').css('opacity', '0');
            }

            this.changeCheckoutData(
                false,
                $switcher,
                $('.pricebox-dropship.basic'),
                $('#SignUpModalDropshipBasic'),
                options.basicMonthly,
                options.toggleCallback || null
            );
            this.changeCheckoutData(
                false,
                $switcher,
                $('.pricebox-dropship.premium'),
                $('#SignUpModalDropshipPremium'),
                options.premiumMonthly,
                options.toggleCallback || null
            );
        });

        $switcher.on('click', '#filt-javascript', (e) => {
            if (typeof options.percentOff !== 'undefined') {
                $switcher.find(options.percentOff).css('opacity', '1');
            } else {
                $switcher.find('#filt-javascript').next('span').css('opacity', '1');
            }

            this.changeCheckoutData(
                true,
                $switcher,
                $('.pricebox-dropship.basic'),
                $('#SignUpModalDropshipBasic'),
                options.basicAnnual,
                options.toggleCallback || null
            );

            this.changeCheckoutData(
                true,
                $switcher,
                $('.pricebox-dropship.premium'),
                $('#SignUpModalDropshipPremium'),
                options.premiumAnnual,
                options.toggleCallback || null
            );
        });

        if (triggerToggleChange) {
            if ($switcher.find('input.check').is(':checked')) {
                $switcher.find('#filt-javascript').trigger('click');
            } else {
                $switcher.find('#filt-css').trigger('click');
            }
        }
    },

    initSHOnePricing(parent = '#Pricing', options = {}, triggerToggleChange = true) {
        options = $.extend({}, options);
        options.starterAnnual = $.extend({ name: 'StarterAnnual', code: 'hp86ir', price: 9, perHtml: 'USD<br>/mo', billing: 'Billed annually' }, options.starterAnnual || {});
        options.proAnnual = $.extend({ name: 'ProAnnual', code: 'xo6uok', price: 49, perHtml: 'USD<br>/mo', billing: 'Billed annually' }, options.proAnnual || {});
        options.starterLifetime = $.extend({ name: 'StarterLifetime', code: 'eq8aqu', price: 299, per: 'USD', billing: 'One-time payment' }, options.starterLifetime || {});
        options.proLifetime = $.extend({ name: 'ProLifetime', code: 'tmmuqz', price: 1699, per: 'USD', billing: 'One-time payment' }, options.proLifetime || {});
        SaleHoo.TrackedEvents.Checkout.loadCheckoutData([
            options.starterAnnual.code,
            options.proAnnual.code,
            options.starterLifetime.code,
            options.proLifetime.code
        ]);

        let $switcher = $(parent).find('.switch-toggle');

        const trialCallBack = (toggled, $switcher, $priceBox, $modal, pricing) => {
            if ($priceBox.hasClass('sh-one-trial')) {
                const trialActive = !toggled,
                    $trialText = $priceBox.find('.trial-text'),
                    $trialButton = $priceBox.find('button[data-bs-toggle="modal"].trial-button'),
                    $accessButton = $priceBox.find('button[data-bs-toggle="modal"]:not(.trial-button)');

                if (trialActive) {
                    $trialText.css('visibility', 'visible');
                    $trialButton.removeClass('d-none');
                    $accessButton.addClass('d-none');
                } else {
                    $trialText.css('visibility', 'hidden');
                    $trialButton.addClass('d-none');
                    $accessButton.removeClass('d-none');
                }
            }

            if (options.toggleCallback) {
                toggleCallback.call(this, toggled, $switcher, $priceBox, $modal, pricing);
            }
        }

        $switcher.on('click', 'input.check', (e) => {
            if ($(e.target).prop('checked')) {
                $(e.delegateTarget).find('#filt-javascript').trigger('click');
            } else {
                $(e.delegateTarget).find('#filt-css').trigger('click');
            }
        });

        $switcher.on('click', '#filt-css', (e) => {
            if (typeof options.percentOff !== 'undefined') {
                $switcher.find(options.percentOff).css('opacity', '0');
            } else {
                $switcher.find('#filt-javascript').next('span').css('opacity', '0');
            }

            this.changeCheckoutData(
                false,
                $switcher,
                $('.price-box.sh-one-starter'),
                $('#SignUpModalSHOneStarter'),
                options.starterAnnual,
                trialCallBack
            );
            this.changeCheckoutData(
                false,
                $switcher,
                $('.price-box.sh-one-pro'),
                $('#SignUpModalSHOnePro'),
                options.proAnnual,
                trialCallBack
            );
        });

        $switcher.on('click', '#filt-javascript', (e) => {
            if (typeof options.percentOff !== 'undefined') {
                $switcher.find(options.percentOff).css('opacity', '1');
            } else {
                $switcher.find('#filt-javascript').next('span').css('opacity', '1');
            }

            this.changeCheckoutData(
                true,
                $switcher,
                $('.price-box.sh-one-starter'),
                $('#SignUpModalSHOneStarter'),
                options.starterLifetime,
                trialCallBack
            );

            this.changeCheckoutData(
                true,
                $switcher,
                $('.price-box.sh-one-pro'),
                $('#SignUpModalSHOnePro'),
                options.proLifetime,
                trialCallBack
            );
        });

        if (triggerToggleChange) {
            if ($switcher.find('input.check').is(':checked')) {
                $switcher.find('#filt-javascript').trigger('click');
            } else {
                $switcher.find('#filt-css').trigger('click');
            }
        }
    },

    initInsightsPricing(options = {}) {
        options = $.extend({}, options);
        options.monthly = $.extend({
            code: 'imyc05',
            price: 20,
            billingTermShort: 'Billed monthly'
        }, options.monthly || {});
        options.annually = $.extend({
            code: 'xetb6d',
            price: 15,
            billingTermShort: 'Billed annually at $180/year'
        }, options.annually || {});

        $('#Insights-Billed-Monthly')
            .find('.order-slug').val(options.monthly.code).end()
            .find('.order-preferred-option').val(options.monthly.code).end()
            .find('.price .num').text(options.monthly.price).end()
            .find('.billing-term-short').text(options.monthly.billingTermShort);

        $('#Insights-Billed-Annually').find('.order-slug').val(options.annually.code).end()
            .find('.order-preferred-option').val(options.annually.code).end()
            .find('.price .num').text(options.annually.price).end()
            .find('.billing-term-short').text(options.monthly.billingTermShort);

        $('#Pricing .switch-toggle').on('click', 'input.check', function (e) {
            if ($(e.target).prop('checked')) {
                $(e.delegateTarget).find('#filt-javascript').trigger('click');
            } else {
                $(e.delegateTarget).find('#filt-css').trigger('click');
            }
        }).on('click', '#filt-css', function () {
            $('.price-col-monthly').removeClass('d-none');
            $('.price-col-annually').addClass('d-none');
            $(this).addClass('toggler--is-active');
            $('#filt-javascript').removeClass('toggler--is-active');
            $('input.check').prop('checked', false);
        }).on('click', '#filt-javascript', function () {
            $('.price-col-monthly').addClass('d-none');
            $('.price-col-annually').removeClass('d-none');
            $(this).addClass('toggler--is-active');
            $('#filt-css').removeClass('toggler--is-active');
            $('input.check').prop('checked', true);
        });
    },

    initInsightsV2Pricing(parent, options = {}) {
        options = $.extend({}, options);
        options.monthly = $.extend({
            price: 20
        }, options.monthly || {});
        options.annually = $.extend({
            price: 180
        }, options.annually || {});

        let $switcher = $(parent).find('.switch-toggle');

        $switcher.on('click', 'input.check', (e) => {
            if ($(e.target).prop('checked')) {
                // annual
                $(e.delegateTarget).find('#insights-filt-javascript').trigger('click');
            } else {
                // monthly
                $(e.delegateTarget).find('#insights-filt-css').trigger('click');
            }
        });

        // monthly
        $switcher.on('click', '#insights-filt-css', (e) => {
            $switcher.find('#insights-filt-javascript').next('span').css('opacity', '0');
            $switcher.find('.toggler').removeClass('toggler--is-active');
            $(e.currentTarget).addClass('toggler--is-active');

            let $container = $('#id-insights1');

            $container.find('.number .num').text(options.monthly.price);
            $container.find('.price .period').text('month');
            $container.find('button.annual').hide();
            $container.find('button.month').show();
            $container.find('li.monthly').show();
            $container.find('li.annual').hide();

            $switcher.find('input').prop('checked', false);
        });

        // annual
        $switcher.on('click', '#insights-filt-javascript', (e) => {
            $switcher.find('#insights-filt-javascript').next('span').css('opacity', '1');
            $switcher.find('.toggler').removeClass('toggler--is-active');
            $(e.currentTarget).addClass('toggler--is-active');

            let $container = $('#id-insights1');

            $container.find('.number .num').text(options.annually.price);
            $container.find('.price .period').text('year');
            $container.find('button.annual').show();
            $container.find('button.month').hide();
            $container.find('li.monthly').hide();
            $container.find('li.annual').show();

            $switcher.find('input').prop('checked', true);
        });

        if ($switcher.find('input.check').is(':checked')) {
            $switcher.find('#insights-filt-javascript').trigger('click');
        } else {
            $switcher.find('#insights-filt-css').trigger('click');
        }
    },

    initEcommercePricing(parent = '', options = {}) {
        options = $.extend({}, options);
        options.oneoff = $.extend({ name: 'One-off Payment', code: 'knu5xi', price: 267, headText: 'Single Payment'}, options.oneoff || {});
        options.installments = $.extend({name: '3 Easy Installments', code: 'avdqn6', price: 89, headText: '3-Monthly Payment Plan'}, options.installments || {});
        SaleHoo.TrackedEvents.Checkout.loadCheckoutData([options.oneoff.code, options.installments.code]);

        let parentSelectors = '#SignUpModalEcommerce, .pricing-container';

        if (parent) {
            parentSelectors = parent;
        }

        const $switcher = $(parentSelectors).find('.switch-toggle');
        const $modal = $(parentSelectors).hasClass('modal') ? $(parentSelectors) : $('#SignUpModalEcommerce');

        $switcher.on('click', 'input.check', (e) => {
            if ($(e.target).prop('checked')) {
                $(e.delegateTarget).find('.toggler.filt-javascript').trigger('click');
            } else {
                $(e.delegateTarget).find('.toggler.filt-css').trigger('click');
            }
        });
        $switcher.on('click', '.toggler.filt-css', (e) => {
            this.changeCheckoutData(
                false,
                $switcher,
                $('.pricebox, .price-box'),
                $modal,
                options.oneoff,
                options.toggleCallback || null
            );
        })
        $switcher.on('click', '.toggler.filt-javascript', (e) => {
            this.changeCheckoutData(
                true,
                $switcher,
                $('.pricebox, .price-box'),
                $modal,
                options.installments,
                options.toggleCallback || null
            );
        });
        $switcher.find('.toggler.filt-css').trigger('click');
    },

    changeCheckoutData(toggled, $switcher, $priceBox, $modal, pricing, toggleCallback = null) {
        $switcher.find('.toggler').removeClass('toggler--is-active');

        $modal.find('.order-preferred-option').val(pricing.code);
        $modal.find('.order-slug').val(pricing.code).trigger('change');
        $modal.find('.price .num').text(pricing.price);
        if (pricing.perHtml) {
            $modal.find('.price .per').html(pricing.perHtml);
        } else {
            $modal.find('.price .per').text(pricing.per);
        }

        $priceBox.find('.price .num, .amount .number').text(pricing.price);
        if (pricing.perHtml) {
            $priceBox.find('.price .per').html(pricing.perHtml);
        } else {
            $priceBox.find('.price .per').text(pricing.per);
        }

        if (pricing.billing) {
            $modal.find('.billing').text(pricing.billing);
            $priceBox.find('.billing').text(pricing.billing);
        }

        if (pricing.headText) {
            $priceBox.find('.head-text').text(pricing.headText);
            $modal.find('.head-text').text(pricing.headText);
        }

        if (toggled) {
            $switcher.find('input').prop('checked', true);
            $switcher.find('#filt-javascript, .filt-javascript').addClass('toggler--is-active');

            $modal.find('.ribbon').show();

            $priceBox.find('.ribbon').show();
        } else {
            $switcher.find('input').prop('checked', false);
            $switcher.find('#filt-css, .filt-css').addClass('toggler--is-active');

            $modal.find('.ribbon').hide();

            $priceBox.find('.ribbon').hide();
        }

        if (typeof toggleCallback === 'function') {
            toggleCallback.call(this, toggled, $switcher, $priceBox, $modal, pricing);
        }
    }
};

window.ProductPricing = ProductPricing;
